// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__cewju","content":"app_content__ckDFI","detail":"app_detail__Xmsnl","list":"app_list__2we4s"};